import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LibrariesCard } from "../../shared/libraries-card/libraries-card";
import { BaseCarouselComponent } from '../../base/base-carousel-component';
import { HomeService } from './home.service';
import { IndexCardComponent } from '../../features/browse-index/components/index-card/index-card.component';
import { BiblioMapper } from '../../features/browse-index/mappers/biblio.mapper';
import { map, catchError } from 'rxjs/operators';
import { Router, RouterLink } from '@angular/router';
import { of } from 'rxjs';
// import { Library } from '../../types/library';
import { Library } from '../../types/library';

import { SkeletonCardComponent } from '../../features/browse-index/components/skeleton-card/skeleton-card.component';

@Component({
  selector: 'app-home',
  imports: [FormsModule, TranslateModule, CommonModule, LibrariesCard, IndexCardComponent, RouterLink, SkeletonCardComponent],
  templateUrl: './home.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrl: './home.scss',
})
export class Home extends BaseCarouselComponent implements OnInit {

  _homeService = inject(HomeService);
  _router = inject(Router);
  searchInputValue: string = ''
  topLibrariesError = signal(false);
  latestBibliosError = signal(false);
  kawLibraryError = signal(false);

  topLibraries$ = this._homeService.getTopLibraries().pipe(
    catchError(() => {
      this.topLibrariesError.set(true);
      return of([]);
    })
  );

  kawLibrary$ = this._homeService.getLibraryKAW().pipe(
    map(kaw => {
      if (kaw && kaw.library_hours && kaw.library_hours.length > 0) {
        kaw.library_hours = this.combineLibraryHours(kaw.library_hours);
      }
      return kaw;
    }),
    catchError(() => {
      this.kawLibraryError.set(true);
      return of(null);
    })
  );

  latestBiblios$ = this._homeService.getLatestBiblios().pipe(
    map(biblios => BiblioMapper.toModelList(biblios)),
    catchError(() => {
      this.latestBibliosError.set(true);
      return of([]);
    })
  );
 media: Library[] = [
  {
    library_id: 'LIB001',
    name: 'Central Library',
    address1: '123 Main Street',
    address2: 'Building A',
    address3: '',
    postal_code: '12345',
    city: 'Cairo',
    state: 'Cairo Governorate',
    country: 'Egypt',
    phone: '+20 100 123 4567',
    fax: '+20 2 1234 5678',
    email: 'info@centrallibrary.com',
    ill_email: 'ill@centrallibrary.com',
    reply_to_email: 'noreply@centrallibrary.com',
    return_path_email: 'bounce@centrallibrary.com',
    url: 'https://centrallibrary.com',
    ip: '192.168.1.1',
    notes: 'Main public library.',
    geolocation: '30.0444,31.2357',
    marc_org_code: 'CL001',
    pickup_location: true,
    pickup_items: [],
    public: true,
    smtp_server: null,
    needs_override: false,
    library_hours: [],
    cash_registers: [],
    desks: []
  },
  {
    library_id: 'LIB002',
    name: 'University Library',
    address1: '456 University Road',
    address2: '',
    address3: '',
    postal_code: '54321',
    city: 'Alexandria',
    state: 'Alexandria Governorate',
    country: 'Egypt',
    phone: '+20 101 987 6543',
    fax: '',
    email: 'contact@unilibrary.edu',
    ill_email: 'ill@unilibrary.edu',
    reply_to_email: 'support@unilibrary.edu',
    return_path_email: 'bounce@unilibrary.edu',
    url: 'https://unilibrary.edu',
    ip: '192.168.1.2',
    notes: 'Library for university students.',
    geolocation: '31.2001,29.9187',
    marc_org_code: 'UL002',
    pickup_location: true,
    pickup_items: [],
    public: false,
    smtp_server: null,
    needs_override: false,
    library_hours: [],
    cash_registers: [],
    desks: []
  },
  {
    library_id: 'LIB003',
    name: 'Community Library',
    address1: '789 Community Ave',
    address2: '',
    address3: '',
    postal_code: '67890',
    city: 'Mansoura',
    state: 'Dakahlia',
    country: 'Egypt',
    phone: '+20 102 555 1234',
    fax: '',
    email: 'info@communitylibrary.org',
    ill_email: 'ill@communitylibrary.org',
    reply_to_email: 'reply@communitylibrary.org',
    return_path_email: 'bounce@communitylibrary.org',
    url: 'https://communitylibrary.org',
    ip: '192.168.1.3',
    notes: 'Local community library.',
    geolocation: '31.0409,31.3785',
    marc_org_code: 'CM003',
    pickup_location: false,
    pickup_items: [],
    public: true,
    smtp_server: null,
    needs_override: false,
    library_hours: [],
    cash_registers: [],
    desks: []
  },
   {
    library_id: 'LIB001',
    name: 'Central Library',
    address1: '123 Main Street',
    address2: 'Building A',
    address3: '',
    postal_code: '12345',
    city: 'Cairo',
    state: 'Cairo Governorate',
    country: 'Egypt',
    phone: '+20 100 123 4567',
    fax: '+20 2 1234 5678',
    email: 'info@centrallibrary.com',
    ill_email: 'ill@centrallibrary.com',
    reply_to_email: 'noreply@centrallibrary.com',
    return_path_email: 'bounce@centrallibrary.com',
    url: 'https://centrallibrary.com',
    ip: '192.168.1.1',
    notes: 'Main public library.',
    geolocation: '30.0444,31.2357',
    marc_org_code: 'CL001',
    pickup_location: true,
    pickup_items: [],
    public: true,
    smtp_server: null,
    needs_override: false,
    library_hours: [],
    cash_registers: [],
    desks: []
  },
  {
    library_id: 'LIB002',
    name: 'University Library',
    address1: '456 University Road',
    address2: '',
    address3: '',
    postal_code: '54321',
    city: 'Alexandria',
    state: 'Alexandria Governorate',
    country: 'Egypt',
    phone: '+20 101 987 6543',
    fax: '',
    email: 'contact@unilibrary.edu',
    ill_email: 'ill@unilibrary.edu',
    reply_to_email: 'support@unilibrary.edu',
    return_path_email: 'bounce@unilibrary.edu',
    url: 'https://unilibrary.edu',
    ip: '192.168.1.2',
    notes: 'Library for university students.',
    geolocation: '31.2001,29.9187',
    marc_org_code: 'UL002',
    pickup_location: true,
    pickup_items: [],
    public: false,
    smtp_server: null,
    needs_override: false,
    library_hours: [],
    cash_registers: [],
    desks: []
  },
  {
    library_id: 'LIB003',
    name: 'Community Library',
    address1: '789 Community Ave',
    address2: '',
    address3: '',
    postal_code: '67890',
    city: 'Mansoura',
    state: 'Dakahlia',
    country: 'Egypt',
    phone: '+20 102 555 1234',
    fax: '',
    email: 'info@communitylibrary.org',
    ill_email: 'ill@communitylibrary.org',
    reply_to_email: 'reply@communitylibrary.org',
    return_path_email: 'bounce@communitylibrary.org',
    url: 'https://communitylibrary.org',
    ip: '192.168.1.3',
    notes: 'Local community library.',
    geolocation: '31.0409,31.3785',
    marc_org_code: 'CM003',
    pickup_location: false,
    pickup_items: [],
    public: true,
    smtp_server: null,
    needs_override: false,
    library_hours: [],
    cash_registers: [],
    desks: []
  }, {
    library_id: 'LIB001',
    name: 'Central Library',
    address1: '123 Main Street',
    address2: 'Building A',
    address3: '',
    postal_code: '12345',
    city: 'Cairo',
    state: 'Cairo Governorate',
    country: 'Egypt',
    phone: '+20 100 123 4567',
    fax: '+20 2 1234 5678',
    email: 'info@centrallibrary.com',
    ill_email: 'ill@centrallibrary.com',
    reply_to_email: 'noreply@centrallibrary.com',
    return_path_email: 'bounce@centrallibrary.com',
    url: 'https://centrallibrary.com',
    ip: '192.168.1.1',
    notes: 'Main public library.',
    geolocation: '30.0444,31.2357',
    marc_org_code: 'CL001',
    pickup_location: true,
    pickup_items: [],
    public: true,
    smtp_server: null,
    needs_override: false,
    library_hours: [],
    cash_registers: [],
    desks: []
  },
  {
    library_id: 'LIB002',
    name: 'University Library',
    address1: '456 University Road',
    address2: '',
    address3: '',
    postal_code: '54321',
    city: 'Alexandria',
    state: 'Alexandria Governorate',
    country: 'Egypt',
    phone: '+20 101 987 6543',
    fax: '',
    email: 'contact@unilibrary.edu',
    ill_email: 'ill@unilibrary.edu',
    reply_to_email: 'support@unilibrary.edu',
    return_path_email: 'bounce@unilibrary.edu',
    url: 'https://unilibrary.edu',
    ip: '192.168.1.2',
    notes: 'Library for university students.',
    geolocation: '31.2001,29.9187',
    marc_org_code: 'UL002',
    pickup_location: true,
    pickup_items: [],
    public: false,
    smtp_server: null,
    needs_override: false,
    library_hours: [],
    cash_registers: [],
    desks: []
  },
  {
    library_id: 'LIB003',
    name: 'Community Library',
    address1: '789 Community Ave',
    address2: '',
    address3: '',
    postal_code: '67890',
    city: 'Mansoura',
    state: 'Dakahlia',
    country: 'Egypt',
    phone: '+20 102 555 1234',
    fax: '',
    email: 'info@communitylibrary.org',
    ill_email: 'ill@communitylibrary.org',
    reply_to_email: 'reply@communitylibrary.org',
    return_path_email: 'bounce@communitylibrary.org',
    url: 'https://communitylibrary.org',
    ip: '192.168.1.3',
    notes: 'Local community library.',
    geolocation: '31.0409,31.3785',
    marc_org_code: 'CM003',
    pickup_location: false,
    pickup_items: [],
    public: true,
    smtp_server: null,
    needs_override: false,
    library_hours: [],
    cash_registers: [],
    desks: []
  }, {
    library_id: 'LIB001',
    name: 'Central Library',
    address1: '123 Main Street',
    address2: 'Building A',
    address3: '',
    postal_code: '12345',
    city: 'Cairo',
    state: 'Cairo Governorate',
    country: 'Egypt',
    phone: '+20 100 123 4567',
    fax: '+20 2 1234 5678',
    email: 'info@centrallibrary.com',
    ill_email: 'ill@centrallibrary.com',
    reply_to_email: 'noreply@centrallibrary.com',
    return_path_email: 'bounce@centrallibrary.com',
    url: 'https://centrallibrary.com',
    ip: '192.168.1.1',
    notes: 'Main public library.',
    geolocation: '30.0444,31.2357',
    marc_org_code: 'CL001',
    pickup_location: true,
    pickup_items: [],
    public: true,
    smtp_server: null,
    needs_override: false,
    library_hours: [],
    cash_registers: [],
    desks: []
  },
  {
    library_id: 'LIB002',
    name: 'University Library',
    address1: '456 University Road',
    address2: '',
    address3: '',
    postal_code: '54321',
    city: 'Alexandria',
    state: 'Alexandria Governorate',
    country: 'Egypt',
    phone: '+20 101 987 6543',
    fax: '',
    email: 'contact@unilibrary.edu',
    ill_email: 'ill@unilibrary.edu',
    reply_to_email: 'support@unilibrary.edu',
    return_path_email: 'bounce@unilibrary.edu',
    url: 'https://unilibrary.edu',
    ip: '192.168.1.2',
    notes: 'Library for university students.',
    geolocation: '31.2001,29.9187',
    marc_org_code: 'UL002',
    pickup_location: true,
    pickup_items: [],
    public: false,
    smtp_server: null,
    needs_override: false,
    library_hours: [],
    cash_registers: [],
    desks: []
  },
  {
    library_id: 'LIB003',
    name: 'Community Library',
    address1: '789 Community Ave',
    address2: '',
    address3: '',
    postal_code: '67890',
    city: 'Mansoura',
    state: 'Dakahlia',
    country: 'Egypt',
    phone: '+20 102 555 1234',
    fax: '',
    email: 'info@communitylibrary.org',
    ill_email: 'ill@communitylibrary.org',
    reply_to_email: 'reply@communitylibrary.org',
    return_path_email: 'bounce@communitylibrary.org',
    url: 'https://communitylibrary.org',
    ip: '192.168.1.3',
    notes: 'Local community library.',
    geolocation: '31.0409,31.3785',
    marc_org_code: 'CM003',
    pickup_location: false,
    pickup_items: [],
    public: true,
    smtp_server: null,
    needs_override: false,
    library_hours: [],
    cash_registers: [],
    desks: []
  }
];
  override ngOnInit(): void {
    super.ngOnInit();
  }



  combineLibraryHours(hours: any[]): any[] {
    if (!hours || hours.length === 0) return [];
    
    // Sort hours by day (0=Sunday to 6=Saturday)
    const sortedHours = [...hours].sort((a, b) => parseInt(a.day) - parseInt(b.day));
    
    const combined: any[] = [];
    let currentGroup: any = null;

    for (const hour of sortedHours) {
      if (!currentGroup) {
        currentGroup = { ...hour, start_day: hour.day, end_day: hour.day };
      } else {
        if (hour.open_time === currentGroup.open_time && hour.close_time === currentGroup.close_time && parseInt(hour.day) === parseInt(currentGroup.end_day) + 1) {
          currentGroup.end_day = hour.day;
        } else {
          combined.push(currentGroup);
          currentGroup = { ...hour, start_day: hour.day, end_day: hour.day };
        }
      }
    }
    if (currentGroup) {
      combined.push(currentGroup);
    }
    
    return combined;
  }

  formatTime(time: string): { h: string, m: string, ampm: string } {
    if (!time) return { h: '', m: '', ampm: '' };
    const [hours, minutes] = time.split(':');
    let h = parseInt(hours, 10);
    const ampm = h >= 12 ? 'pm' : 'am';
    h = h % 12;
    h = h ? h : 12;
    return { h: h.toString(), m: minutes, ampm };
  }

  onSearchClick(value: string) {

    this._router.navigate(
      ['/browse-index'],
      {
        queryParams: {
          q: value
        }
      })
  }
}

